import { render, staticRenderFns } from "./AscRichTextInput.vue?vue&type=template&id=ac83277a&"
import script from "./AscRichTextInput.vue?vue&type=script&lang=js&"
export * from "./AscRichTextInput.vue?vue&type=script&lang=js&"
import style0 from "./AscRichTextInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCounter } from 'vuetify/lib/components/VCounter';
import { VMessages } from 'vuetify/lib/components/VMessages';
installComponents(component, {VCounter,VMessages})
